import React from "react";
import "./CustomerSupport.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhoneAlt, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import {
  faWhatsapp,
  faFacebook,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";

const CustomerSupport = () => {
  return (
    <div className="container-customer">
      <div className="row">
        <div className="images-column">
          <div className="images-container">
            <img
              src="/images/misc/Principal-slogan.png"
              alt="Imagen pequeña"
              className="small-image"
            />
            <img
              src="/images/misc/Imagen-footer.png?height=400&width=500"
              alt="Atención al cliente"
              className="support-image"
            />
          </div>
        </div>
        <div className="contact-column">
          <div className="contact-info">
            <h2>Atención al cliente</h2>
            <p>
              Puedes contactarnos vía
              <span className="highlight">WhatsApp, </span>
              <span className="highlight">correo o a través de nuestras</span>
              <span className="highlight">redes sociales.</span>
            </p>
            <div className="contact-details">
              <div className="contact-item icons-contact">
                <FontAwesomeIcon icon={faPhoneAlt} />
                <a
                  href="tel:0990441331"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <span>099 044 1331</span>
                </a>
              </div>
              <div className="contact-item icons-contact">
                <FontAwesomeIcon icon={faEnvelope} />
                <a
                  href="mailto:info@fibralink.ec"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <span>info@fibralink.ec</span>
                </a>
              </div>
              <div className="contact-item social-icons">
                {/* Icono de WhatsApp con enlace */}
                <a
                  href="https://wa.me/593990441331"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <FontAwesomeIcon icon={faWhatsapp} />
                </a>

                {/* Icono de Facebook con enlace */}
                <a
                  href="https://www.facebook.com/fibralinkec/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <FontAwesomeIcon icon={faFacebook} />
                </a>

                {/* Icono de Instagram con enlace */}
                <a
                  href="https://www.instagram.com/fibralinkec/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerSupport;
